export default __webpack_public_path__ + "static/media/480_dummy2016-kunsthandwerk01-de.18053399.png";